import React, { Component } from 'react';
import PropsType from 'prop-types';
import _ from 'lodash';

import ZCTouch from '../ZCTouch';

import "./ZCMsg.css";

class ZCMButtons extends Component {

  static propTypes = {
    buttons: PropsType.array,
    disabled: PropsType.bool
  };

  static defaultProps = {
    buttons: [],
    disabled: true
  };

  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    this.setState((state, props) => ({
      ...props
    }));
  }

  static getDerivedStateFromProps(nextProps, prevStat) {
    if (prevStat !== nextProps) {
      return {
        ...nextProps
      };
    }
  }

  renderButtons() {
    let { cssPrefix, buttons, _onQuickReply, onPhoneClick, onWebClick, disabled } = this.state;

    let rendered = [];
    _.map(buttons, (o, i) => {
      let func = null;
      switch (o.type) {
        case 'web':
          func = () => onWebClick(o.payload);
          break;
        case 'phone':
          func = () => onPhoneClick(o.payload);
          break;
        default:
          func = () => _onQuickReply(o);
          break;
      }

      rendered.push(
        <div key={i} className={cssPrefix + " zchat-msg-btn "}>
          <ZCTouch cssPrefix={cssPrefix} onPress={func} >
            <div className={cssPrefix + " zchat-msg-btn-text "}>
              {o.title}
            </div>
          </ZCTouch>
        </div>
        // <div key={i} className={cssPrefix + " zchat-msg-btn " + (disabled ? "disabled" : "")}>
        //   <ZCTouch cssPrefix={cssPrefix} onPress={func} disabled={disabled}>
        //     <div className={cssPrefix + " zchat-msg-btn-text " + (disabled ? "disabled" : "")}>
        //       {o.title}
        //     </div>
        //   </ZCTouch>
        // </div>
      );
    });

    return rendered;
  }

  render() {
    let { cssPrefix } = this.state;
    return (
      <div className={cssPrefix + " zchat-msg-btnlist"}>
        {this.renderButtons()}
      </div>
    );
  }
}

export default ZCMButtons;